import * as React from 'react'

import { useExternalEmbroidery } from '../../../containers/EmbroideryContainer/providers/facade'

import { Template } from './Template'

export const EmbroiderySummary: React.FC = () => {
  const { embroiderySummary, openEmbroideryModal } = useExternalEmbroidery()

  return <Template {...embroiderySummary} openEmbroideryModal={openEmbroideryModal} />
}
